module.exports = __webpack_public_path__ + "static/preschool-755ab45e94d2eaaa699fa2a173e91246.jpg";